export const daimo = {
  // REQUIRED: replace with your App ID
  appId: "pay-dsro-k8FUu4522lQwP",
  // Base chain id
  toChain: 10,
  // Base USDC
  toToken: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85" as const,
  // REQUIRED: destination address to receive funds
  toAddress: "0xcF71b3eC736099a5d4dE98ee360a228f504D8F13",
  // Where to return after donation
  returnUrl: "https://groundwire.io/",
};
